const tecnologycontent = [
    {id:0,
        tec:"Tecnologias",
    headerSubTitle:"Estudante Ciência de dados - Faculdade Descomplica"
    },
    {
    id:1,
    tec:"Tecnology",
    headerSubTitle:"Data science student at Descomplica university"
    }
]
export default tecnologycontent